import React from 'react';

export const FrequentFlyerIcon = ({ fill = '#E1F4D3', color = '#1C452B', width = 20, height = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.8706 2.87984C28.6343 2.45829 28.2899 2.10732 27.873 1.86304C27.456 1.61876 26.9815 1.48999 26.4983 1.48999C26.015 1.48999 25.5405 1.61876 25.1235 1.86304C24.7066 2.10732 24.3622 2.45829 24.126 2.87984C21.8008 7.09545 19.8873 11.5253 18.4119 16.108C18.0258 17.3053 16.8813 18.1358 15.5702 18.172C11.5956 18.2764 7.63406 18.671 3.71703 19.3526C1.56696 19.7303 0.758607 22.1804 2.28643 23.6749C5.24955 26.5739 8.41503 29.2585 11.7589 31.7085C12.7784 32.4557 13.1979 33.7363 12.809 34.9086C11.3244 39.3608 10.2641 43.9433 9.64221 48.5951C9.36442 50.6924 11.6089 52.173 13.559 51.1729C17.4259 49.1903 21.1236 46.8936 24.6149 44.3061C25.1614 43.9061 25.821 43.6905 26.4983 43.6905C27.1755 43.6905 27.8351 43.9061 28.3817 44.3061C31.8723 46.8945 35.5701 49.1912 39.4375 51.1729C41.3848 52.173 43.6321 50.6924 43.3543 48.5951C42.7325 43.9424 41.6722 39.3589 40.1876 34.9058C39.7987 33.7391 40.2153 32.4557 41.2376 31.7085C44.5814 29.2584 47.7469 26.5738 50.7101 23.6749C52.2379 22.1804 51.4323 19.7303 49.2795 19.3526C45.3629 18.6675 41.4011 18.2729 37.4264 18.172C36.7976 18.1632 36.187 17.9601 35.6782 17.5906C35.1695 17.221 34.7875 16.7032 34.5846 16.108C33.109 11.5263 31.1955 7.09459 28.8706 2.87984Z"
        fill={fill}
        stroke={color}
        strokeWidth="2.98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
